/** Whole rupees for storefront / admin price display */
export function formatInrWhole(amount) {
  if (amount == null || Number.isNaN(Number(amount))) return '—';
  return `₹${Math.round(Number(amount)).toLocaleString('en-IN')}`;
}

export function formatInrWholeNumber(amount) {
  if (amount == null || Number.isNaN(Number(amount))) return null;
  return Math.round(Number(amount));
}

/** Small caption for live-priced items: subtotal + GST (not for fixed-price products). */
export function jewelGstCaption(jewel) {
  if (!jewel || jewel.gst_amount == null || jewel.price_subtotal == null) return null;
  const sub = formatInrWholeNumber(jewel.price_subtotal);
  const gst = formatInrWholeNumber(jewel.gst_amount);
  if (sub == null || gst == null) return null;
  return `₹${sub.toLocaleString('en-IN')} + ₹${gst.toLocaleString('en-IN')} GST`;
}
